import {
  GET_USERS,
  initialState,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
  UsersState,
  UsersActions,
  DELETE_USER,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  GET_USER_DATA,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_ERROR,
  UPDATE_SELECTED,
  CREATE_USER_RESET,
  DELETE_USER_RESET,
  DELETE_USER_SOME_ERROR,
  USERS_NOT_DELETED,
} from './types'

import { status } from '../typeStatus'

const reducers = (state: UsersState = initialState, action: UsersActions): UsersState => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        status: status.loading,
        users: null,
      }
    case GET_USERS_SUCCESS:
      return {
        ...state,
        status: status.success,
        users: action.payload.users,
        pagination: action.payload.pagination
      }
    case GET_USERS_ERROR:
      return {
        ...state,
        status: status.error,
        users: null,
      }
    case UPDATE_SELECTED: {
      return {
        ...state,
        listUsers: action.payload,
      }
    }
    case DELETE_USER:
      return {
        ...state,
        deleteUser: {
          status: status.loading,
          isMultiple: action.payload,
        },
      }
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          status: status.success,
        },
      }
    case DELETE_USER_RESET:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          status: status.initial,
        },
      }
    case DELETE_USER_ERROR:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          status: status.error,
        },
      }
    case CREATE_USER:
      return {
        ...state,
        createUser: {
          status: status.loading,
          invalidUsername: false,
        },
        selectedUserData: {
          ...state.selectedUserData,
          isEdit: action.payload,
        },
      }
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        createUser: {
          status: status.success,
          invalidUsername: false,
        },
      }
    case CREATE_USER_RESET:
      return {
        ...state,
        createUser: {
          ...state.createUser,
          status: status.initial,
        },
      }

    case CREATE_USER_ERROR:
      return {
        ...state,
        createUser: {
          status: status.error,
          invalidUsername: action.payload,
        },
      }
    case GET_USER_DATA:
      return {
        ...state,
        selectedUserData: {
          ...state.selectedUserData,
          fetchStatus: status.loading,
          data: null,
        },
      }
    case GET_USER_DATA_SUCCESS:
      return {
        ...state,
        selectedUserData: {
          ...state.selectedUserData,
          fetchStatus: status.success,
          data: action.payload,
        },
      }
    case GET_USER_DATA_ERROR:
      return {
        ...state,
        selectedUserData: {
          ...state.selectedUserData,
          fetchStatus: status.error,
          data: null,
        },
      }
    case DELETE_USER_SOME_ERROR:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          status: status.someError,
        },
      }
    case USERS_NOT_DELETED:
      return {
        ...state,
        usersNotDeleted: action.payload,
      }

    default:
      return state
  }
}

export default reducers
